<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-input placeholder="流水号" v-model="params.channelOrderNo" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="用户ID" v-model="params.user_id" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="门店号" v-model="params.channelStoreNo" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>

      <el-select v-model="params.is_pass" placeholder="通过" clearable @change="searchData" style="width: 15%">
        <el-option
          v-for="item in passList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>

      </el-select>
      <el-select v-model="params.is_send" placeholder="返现" clearable @change="searchData" style="width: 10%">
        <el-option
          v-for="item in sendList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>

      </el-select>
      <el-col :span="2">
        <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
      </el-col>

    </el-row>
    <el-table :data="userList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="members_id" label="门店号" width="250">
        <template slot-scope="scope">
          {{scope.row.channelStoreNo}}
        </template>
      </el-table-column>
      <el-table-column prop="channelOrderNo" label="订单流水号" width="250">
        <template slot-scope="scope">
          <!--        <el-tag :color="scope.row.tag_color" size="mini" :style="'color:'+scope.row.font_color"></el-tag>-->
          {{scope.row.channelOrderNo}}
        </template>
      </el-table-column>

      <el-table-column prop="user_id" label="用户ID" width="250">
        <template slot-scope="scope">
          {{scope.row.user_id}}
        </template>
      </el-table-column>
      <el-table-column prop="userNo" label="方伞权益编号" width="250">
        <template slot-scope="scope">
          {{scope.row.userNo}}
        </template>
      </el-table-column>
      <el-table-column prop="orderTime" label="下单时间" width="250">
        <template slot-scope="scope">
          {{scope.row.orderTime}}
        </template>

      </el-table-column>
      <el-table-column prop="orderAmt" label="实收金额" width="250">
        <template slot-scope="scope">
          {{scope.row.orderAmt}}
        </template>
      </el-table-column>


      <el-table-column prop="benefitAmt" label="试算金额" width="250">
        <template slot-scope="scope">
          {{scope.row.benefitAmt}}
        </template>
      </el-table-column>


      <el-table-column prop="benefitAmt" label="返现金额" width="250">
        <template slot-scope="scope">
          {{scope.row.benefitAmt}}
        </template>
      </el-table-column>


      <el-table-column prop="is_pass" label="通过" width="250">
        <template slot-scope="scope">
          {{scope.row.is_pass}}
        </template>
      </el-table-column>

      <el-table-column prop="is_send" label="返现" width="250">
        <template slot-scope="scope">
          {{scope.row.is_send}}
        </template>
      </el-table-column>
      <el-table-column prop="employee" label="推荐手机号" width="250">
        <template slot-scope="scope">
          {{scope.row.employee}}
        </template>
      </el-table-column>
      <el-table-column prop="cal_msg" label="试算结果" width="250">
        <template slot-scope="scope">
          {{scope.row.cal_msg}}
        </template>
      </el-table-column>
      <el-table-column prop="ordersync_msg" label="上传发票结果" width="250">
        <template slot-scope="scope">
          {{scope.row.ordersync_msg}}
        </template>
      </el-table-column>

      <el-table-column prop="allOrderRealAmt" label="方伞总补贴" width="250">
        <template slot-scope="scope">
          {{scope.row.allOrderRealAmt}}
        </template>
      </el-table-column>
      <el-table-column prop="employeeReward" label="员工奖励" width="250">
        <template slot-scope="scope">
          {{scope.row.employeeReward}}
        </template>
      </el-table-column>
      <el-table-column prop="distributionName" label="门店名" width="250">
        <template slot-scope="scope">
          {{scope.row.distributionName}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="380">
        <template slot-scope="scope">
          <el-button type="text" @click="toEdit(scope.row)">查看图片</el-button>
          <!--          <el-button type="text" @click="isPassAction(scope.$index, scope.row)">通过</el-button>-->
          <el-button type="text" @click="isSendAction(scope.$index, scope.row)"
                     v-if="scope.row.is_trial=='1'&&scope.row.is_send=='未返现'">返现
          </el-button>
          <el-button type="text" @click="editAction(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" @click="isSendEmployee(scope.$index, scope.row)"
                     v-if="scope.row.is_send_employee=='0'">给员工返现
          </el-button>


          <el-button type="text" @click="isTrial(scope.$index, scope.row)" v-if="scope.row.is_trial!='1'">试算</el-button>
          <el-button type="text" @click="isPassAction(scope.$index, scope.row)" v-if="scope.row.is_pass!= '已通过'">上传发票
          </el-button>

        </template>
      </el-table-column>


    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>

    </div>
    <el-dialog
      title="审核"
      :visible.sync="editDialog"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form :model="formdata">
        <el-form-item label="资料" readonly label-width="15%">
          <div class="demo-image__preview">
            <el-image
              style="width: 200px; height: 150px"
              :src="form.img"
              :preview-src-list="[form.img,form.img]">
            </el-image>
            <el-image
              style="width: 200px; height: 150px"
              :src="form.front"
              :preview-src-list="[form.front,form.front]">
            </el-image>
            <el-image
              style="width: 200px; height: 150px"
              :src="form.backend"
              :preview-src-list="[form.backend,form.backend]">
            </el-image>
            <el-image
              style="width: 200px; height: 150px"
              :src="form.drug"
              :preview-src-list="[form.drug,form.drug]">
            </el-image>
            <el-image
              style="width: 200px; height: 150px"
              :src="form.dzqm"
              :preview-src-list="[form.dzqm,form.dzqm]">
            </el-image>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>

  </span>
    </el-dialog>

    <el-dialog title="修改信息" width="40%" :visible.sync="employeeDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">

          <el-form-item class="content-left" label="推荐人" prop="employee">

            <el-input placeholder="请输入推荐人手机号" v-model="form.employee"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="下单时间" prop="orderTime">

            <el-input placeholder="请输入下单时间" v-model="form.orderTime"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="saveEmployeeData">确定保存</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <el-dialog title="修改信息" width="40%" :visible.sync="passDialog" :before-close="invoiceLabelsDialog">
      <template>
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">

          <el-form-item class="content-left" label="发票地址" prop="invoice_img">

            <el-input placeholder="请输入发票地址" v-model="form.invoice_img"></el-input>
          </el-form-item>

          <el-form-item class="content-left" label="用户ID" prop="user_id">

            <el-input placeholder="请输入用户ID" v-model="form.user_id"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="订单号" prop="channelOrderNo">

            <el-input placeholder="请输入订单号" v-model="form.channelOrderNo"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="处方单" prop="drug">

            <el-input placeholder="请输入处方单地址" v-model="form.drug"></el-input>
          </el-form-item>

          <el-form-item class="content-left" label="身份证正面地址" prop="front">

            <el-input placeholder="请输身份证入正面地址" v-model="form.front"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="身份证反面地址" prop="backend">

            <el-input placeholder="请输入身份证反面地址" v-model="form.backend"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="saveInvoice">确定保存</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  // eslint-disable-next-line no-unused-vars
  import {Message} from 'element-ui'
  // eslint-disable-next-line no-unused-vars

  import {
    getOrder,
    sendData,
    passData,
    getOrderData,
    updateEmployee,
    sendEmployee,
    isTrial,
    isPassAction,
    saveInvoice
  } from '../../../api/baoxian'


  export default {
    data() {
      return {

        isEdit: false,
        userList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          card: '',
          employee_id: '',
          pharmacistTel: '',
          phone: '',
          store_inkid: '',
          invoice_pic: '',
          channelStoreNo: '',
        },
        passList: [
          {label: '已通过', value: 1},
          {label: '未通过', value: 0},
          {label: '通过失败', value: 2}
        ],
        sendList: [
          {label: '已返现', value: 1},
          {label: '未返现', value: 0}
        ],
        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',
          img: '',
          description: ''
        },
        editDialog: false,
        memberTagDialog: false,
        employeeDialog: false,
        passDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      toEdit(e) {
        this.editDialog = true
        this.form = e;
        this.url = e.front_photo;
        this.srcList = [e.front_photo, e.reverse_photo];
      },
      handleClose(e) {
        this.editDialog = false;
      },
      invoiceLabelsDialog(e){
        this.invoiceLabelsDialog=false;
        this.getDataList()
      },
      exportData() {
        this.exportloading = true
        this.params.export = 1
        getOrderData(this.params).then(res => {
          this.exportloading = false
          if (res.data.status) {
            this.$message({
              type: 'success',
              message: '已加入执行队列，请在设置-导出列表中下载'
            })
            return
          } else if (res.data.url) {
            this.downloadUrl = res.data.url
            this.downloadName = res.data.filename
            this.downloadView = true
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        }).catch(error => {
          this.exportloading = false
        })
      },
      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.employeeDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },

      saveEmployeeData() {
        this.employeeDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          updateEmployee(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })

        } else {
          this.$message.error('缺少Id')
          this.getDataList()
          //新增方法
          // eslint-disable-next-line no-undef
          // saveKaika(this.form).then(res => {
          //   if (res.data.data) {
          //     this.$message({
          //       type: 'success',
          //       message: '新增成功'
          //     })
          //     this.getDataList()
          //   }
          // })
        }
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.employeeDialog = true
      },
      isSendAction(index, row) {
        this.$confirm('确认返现, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          sendData(row.id).then(response => {

            this.$message({
              message: '返现成功',
              type: 'success',
              duration: 5 * 1000
            }),
              this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '返现失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      isSendEmployee(index, row) {

        this.$confirm('确认给员工返现, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          sendEmployee(row.id).then(response => {
            console.log(response.data.data.msg_code)
            if (response.data.data.msg_code == '0') {
              this.$message({
                type: 'error',
                message: response.data.data.res
              })
            } else {
              this.$message({
                message: '返现成功',
                type: 'success',
                duration: 5 * 1000
              })
            }
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '返现失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      isTrial(index, row) {
        this.$confirm('开始试算, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(row.channelOrderNo)
          isTrial(row.channelOrderNo).then(response => {

            if (response.data.data.code == '200') {

              this.$message({
                message: response.data.data.message,
                type: 'success',
                duration: 5 * 1000
              })
            } else {
              this.$message({
                type: 'error',
                message: '失算失败'
              })
            }
            this.getDataList()
          }).catch(() => {
            console.log(row.channelOrderNo)
            this.$message({
              type: 'error',
              message: '试算失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      saveInvoice() {
        //上传发票
        this.passDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          saveInvoice(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          this.$message.error('缺少Id')
          this.getDataList()
         }
      },
      isPassAction(index, row) {
        //上传发票弹框
        this.form = row
        this.passDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {
        if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.phone)) && this.params.phone != '') {
          this.$message.error('请输入正确手机号')
        } else if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.pharmacistTel)) && this.params.pharmacistTel != '') {
          this.$message.error('请输入正确手机号')
        } else {
          this.params.page = 1
          this.getDataList()
        }
      },
      getDataList() {
        this.loading = true
        getOrder(this.params).then(response => {
          this.userList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.employeeDialog = false
        this.getDataList()
      },
    },
    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }

  .img123 {
    width: 100px;
    height: 100px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// order.vue?3cac21a5